<template>
  <v-dialog
    v-model="enableDialog"
    width="500"
    persistent
  >
    <validation-observer
      ref="ordinanceCityFormValidation"
    >
      <v-form>
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title>
              {{ targetId ? '政令市編集' : '政令市追加' }}
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  class="requiredMark"
                  name="都道府県"
                  >
                  <v-autocomplete
                    v-model="forms.prefecture_code"
                    :error-messages="errors"
                    :items="prefList"
                    item-text="text"
                    item-value="value"
                    label="都道府県"
                    persistent-placeholder
                    required
                    hide-details="auto"
                    />
                </validation-provider>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|alpha_num_only|max:10"
                  class="requiredMark"
                  name="コード"
                >
                  <v-text-field
                    v-model="forms.code"
                    :error-messages="errors"
                    label="コード"
                    hide-details="auto"
                    persistent-placeholder
                    placeholder="例）001"
                    required
                  >
                    <template v-slot:label>
                      <span>コード</span>
                      <span class="ml-1">
                        ({{ forms.code?.length || 0 }} / 10)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:15"
                  class="requiredMark"
                  name="政令市"
                >
                  <v-text-field
                    v-model="forms.name"
                    :error-messages="errors"
                    label="政令市"
                    hide-details="auto"
                    persistent-placeholder
                    placeholder="横浜市"
                    required
                  >
                    <template v-slot:label>
                      <span>政令市</span>
                      <span class="ml-1">
                        ({{ forms.name?.length || 0 }} / 15)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="表示順"
                  rules="numeric|min_value:0|max_value:2147483647"
                >
                  <v-text-field
                    v-model="forms.position"
                    :error-messages="errors"
                    :show-size="1000"
                    label="表示順"
                    hide-details="auto"
                    persistent-placeholder
                    reverse
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeButtonClickEvent">
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              登録
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import PrefectureList from '../../../../../mixins/PrefectureList'
export default {
  components: {},
  mixins: [PrefectureList],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
      forms: {
        id: null,
        prefecture_code: null,
        code: null,
        name: null,
        position: null,
      },
    }
  },
  computed: {
  },
  watch: {
    enableDialog (value) {
      this.$nextTick(() => this.$refs.ordinanceCityFormValidation.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (value) {
        if (this.targetId) {
          this.searchEditOrdinanceCity()
        } else {
          this.searchNewOrdinanceCity()
        }
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('AdminMasterOrdinanceCity', {
      newOrdinanceCity: 'new',
      editOrdinanceCity: 'edit',
      createOrdinanceCity: 'create',
      updateOrdinanceCity: 'update',
    }),
    /**
     * 新規時表示情報取得
     */
    searchNewOrdinanceCity () {
      this.newOrdinanceCity().then((content) => {
        this.forms = content
      })
    },
    /**
     * 編集時表示情報取得
     */
    searchEditOrdinanceCity () {
      this.editOrdinanceCity({ id: this.targetId }).then((content) => {
        this.forms = content
      })
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
    * 登録ボタン クリックイベント
    */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.ordinanceCityFormValidation.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation(){
      if (this.targetId) {
        this.updateOrdinanceCity({ id: this.targetId, params: this.forms}).then(() => {
          this.$emit('registerEvent')
        })
      } else {
        this.createOrdinanceCity({ params: this.forms }).then(() => {
          this.$emit('registerEvent')
        })
      }
    },
  }
}
</script>

<style scoped>
</style>
